
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
//部门
export async function getDepartmentsList(params) {
    return post(erpserver+'/task/getDepartmentsList', params, true)
}
//车间
export async function getWorkshopsList(params) {
    return post(erpserver+'/task/getWorkshopsList', params, true)
}
export async function shiftlist(params) {
    return post(erpserver+'/shift/list', params, true)
}
export async function bcList(params) {
    return post(erpserver+'/shift/bcList', params, true)
}
export async function bzList(params) {
    return post(erpserver+'/shift/bzList', params, true)
}
export async function shiftdelete(params) {
    return post(erpserver+'/shift/delete', params, true)
}
export async function cancel(params) {
    return post(erpserver+'/shift/cancel', params, true)
}
export async function save(params) {
    return post(erpserver+'/shift/save', params, true)
}